<template>
  <div>
    <common-dialog
      ref="dialog"
      :width="width"
      id-key="SectionId"
      show-save-button
      title="展示区域设置"
      :data="data"
      form-label-width="100px"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="data.GoodsType!=1?24:14">
            <el-row>
              <el-col :span="24">
                <el-form-item label="区域顶端图片">
                  <single-upload :data="{dic: 'Section'}" v-model="data.PicUrl" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="data.GoodsType!=1?24:10">
            <el-row>
              <el-col :span="24">
                <el-form-item label="区域序号" prop="Sort">
                  <span>{{data.Sort}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="商品数量" prop="GoodsNumber">
                  <el-input v-model="data.GoodsNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="展示类型" prop="GoodsType">
                  <el-select size="mini" v-model="data.GoodsType" @change="changeType">
                    <el-option label="最新商品" :value="0"></el-option>
                    <el-option label="推荐商品" :value="1"></el-option>
                    <el-option label="商品分类" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="data.GoodsType == 2">
              <el-col :span="24">
                <el-form-item label="商品分类" prop="MallClassId">
                  <class-select ref="classSelect" style="width: 100%;" v-model="data.MallClassId" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row v-if="data.GoodsType == 1">
          <el-col :span="24">
            <el-table ref="table" size="mini" border :data="Goods">
              <el-table-column label="商品名称" prop="GoodsName" />
              <el-table-column label="商品分类" prop="MallClassName" />
              <el-table-column label="商品图片" width="100px" align="center">
                <div class="list-img" slot-scope="{row}" v-if="row.Thumbnail">
                  <el-image :src="'/api'+row.Thumbnail" :preview-src-list="['/api'+row.Thumbnail]">></el-image>
                </div>
              </el-table-column>
              <el-table-column align="center" width="80px">
                <template slot="header">
                  <i class="el-icon-circle-plus-outline add-icon" @click="add"></i>
                </template>
                <template slot-scope="{row}">
                  <el-button icon="el-icon-delete" type="text" @click="del(row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <goods-dialog ref="goodsDialog" in-dialog selectable multiple @select-multiple="setGoods" />
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singleUpload from "@/components/common/photo/singleUpload";
import classSelect from "@/components/mall/goods/showClass/select";
import goodsDialog from "@/components/basicinfo/goods/archives/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singleUpload,
    classSelect,
    goodsDialog,
  },
  data() {
    return {
      api: require("@/api/mall/section").default,
      goods_api: require("@/api/mall/sectionGoods").default,
      data: {
        SectionId: 0,
        SectionName: "",
        SectionType: 0, //0:搜索 1:广告 2:快捷入口 3:商品
        Sort: 0,
        Status: 1, //0:隐藏 1:显示
        AdMode: 0, //0:轮播 1:静态
        Rows: 0,
        Cols: 0,
        EntId: 0,
        PicUrl: "",
        GoodsType: 0, //0:最新商品 1:推荐商品 2:分类
        GoodsNumber: 0,
        MallClassId: 0,
      },
      Goods: [],
      width: "450px",
      rules: {
        GoodsNumber: [
          { required: true, message: "商品数量不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        MallClassId: [{ required: true, message: "商品分类不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      if (this.data.GoodsType == 2) this.$refs.classSelect.getData();
      if (this.data.GoodsType == 1) {
        this.width = "700px";
        this.getGoods();
      }
    },
    onClosed() {
      this.Goods = [];
      this.width = "450px";
    },
    changeType(val) {
      if (val == 2) {
        this.data.MallClassId = null;
        this.$nextTick(() => {
          this.$refs.classSelect.getData();
        });
      } else {
        this.data.MallClassId = 0;
      }
      if (val == 1) {
        this.width = "700px";
        this.getGoods();
      } else {
        this.width = "450px";
        this.Goods = [];
      }
    },
    getGoods() {
      this.goods_api.list({ SectionId: this.data.SectionId }).then((res) => {
        
        this.Goods = res.Data;
      });
    },
    setGoods(goods) {
      
      var data = {
        SectionId: this.data.SectionId,
        GoodsIds: goods.map((x) => x.GoodsId),
      };
      this.goods_api.addGoods(data).then((res) => {
        if (res.Code == 0) this.getGoods();
        else this.$message.error(res.Msg);
      });
    },
    add() {
      let ids = this.Goods.map((x) => x.GoodsId);
      this.$refs.goodsDialog.open().then((that) => {
        that.getTree();
        that.getData({ Status: 1, NotIds: ids });
      });
    },
    del(row) {
      // 
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.goods_api.delete({ id: row.SectionGoodsId }).then((res) => {
            if (res.Code == 0) this.getGoods();
            else this.$message.error(res.Msg);
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.list-img {
  width: 30px;
  height: 30px;
  margin: auto;
}
</style>